export default __webpack_public_path__ + "static/media/Group_900-min.2d41dd87.png";